import React from 'react'
import { getTextToShow } from '../../app/helpers/getTextToShow';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const TableVerticalExperience = ({ selectedField, data }) => {

  const { t } = useTranslation();

  const { listFieldsExperience } = useSelector((state) => state.moduleConfig);
  const { listFullCatalogs } = useSelector((state) => state.catalog);
  const { listFullCatalogCiius } = useSelector((state) => state.catalogCiiu);
  const { listContinents, listFullRegions, listFullCountries } = useSelector((state) => state.locationCountry);

  const selectedData = data.filter(dta => dta.isSelected);

  // Estilos inline para el efecto "Sticky" y Scroll
  const containerStyle = {
    maxHeight: '450px', // Altura máxima antes de activar el scroll
    overflowY: 'auto',
    borderRadius: '8px',
    border: '1px solid #dee2e6'
  };

  const stickyHeaderStyle = {
    position: 'sticky',
    top: 0,
    backgroundColor: '#f8f9fa',
    zIndex: 1,
    boxShadow: '0 2px 2px -1px rgba(0,0,0,0.1)'
  };

  return (
    <div style={containerStyle} className="table-responsive">
      <table className='table table-hover mb-0'>
        <thead style={stickyHeaderStyle}>
          <tr>
            <th className="bg-light" style={{ width: '30%' }}># ID / Código</th>
            <th scope="col" className="bg-light">
              {t(`${selectedField.module_text}.short.${selectedField.field}`)}
            </th>
          </tr>
        </thead>

        <tbody>
          {selectedData.length > 0 ? (
            selectedData.map((dta, index) => (
              <tr key={dta.id || index}>
                <th scope="row" className='text-muted small align-middle'>
                  <span className="badge bg-secondary me-2">{index + 1}</span>
                  {dta.code || dta.id}
                </th>
                <td className="align-middle py-3" style={{ fontSize: '0.95rem', lineHeight: '1.5', textAlign: 'justify' }}>
                  {getTextToShow(
                    selectedField,
                    dta,
                    listFieldsExperience,
                    listFullCatalogs,
                    listFullCatalogCiius,
                    listFullCountries,
                    listFullRegions,
                    listContinents
                  )}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="2" className="text-center p-4 text-muted">
                {t("general.no-data-selected")}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  )
}

export default TableVerticalExperience